/*
 * This file is unchanged, except for removing eslint comments
 */
export function useDocumentTitle() {
  // Noop for native platforms
}
